import { ScannedItem } from "shared/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  renderMaterialItemsStatuses,
  renderMaterialItemsSituations,
} from "shared/helpers";
import { MobileRow } from "./MobileRow";
import { getResultStatus } from "./getResultStatus";

dayjs.extend(utc);
dayjs.extend(timezone);

export const MobileCard = ({ item }: { item: ScannedItem }) => {
  const userTimezone = localStorage.getItem("timezone") || "UTC";

  const { label: resultLabel, className: resultClass } = getResultStatus(
    item.result
  );

  const material = item.material_item?.material_stock_batch?.material;
  const category = material?.material_category;

  const materialItem = item.material_item;

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm active:scale-[0.99] transition-transform">
      <div className="flex items-center justify-between">
        <div className="font-semibold text-gray-900 text-lg">
          {item.serial_number}
        </div>

        <span
          className={`px-2 py-0.5 text-xs rounded-full font-medium ${resultClass}`}
        >
          {resultLabel}
        </span>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3">
        <MobileRow icon="📦" label="Material" value={material?.name ?? "-"} />

        <MobileRow icon="🗂" label="Category" value={category?.name ?? "-"} />

        <MobileRow
          icon="📊"
          label="Quantity"
          value={materialItem?.calc_total_remaining_quantity ?? "-"}
        />

        <MobileRow
          icon="📌"
          label="Status"
          value={
            materialItem
              ? renderMaterialItemsStatuses(materialItem as any)
              : "-"
          }
        />

        <MobileRow
          icon="📍"
          label="Situation"
          value={
            materialItem
              ? renderMaterialItemsSituations(materialItem as any)
              : "-"
          }
        />

        <MobileRow
          icon="🕒"
          label="Last Scanned"
          value={dayjs(materialItem?.last_timestamp_scanned ?? item.timestamp)
            .tz(userTimezone)
            .format("DD MMM YYYY, HH:mm")}
        />

        <MobileRow
          icon="👤"
          label="User"
          value={`${item.user.first_name} ${item.user.last_name}`}
        />

        <MobileRow
          icon={item.is_error ? "❌" : "✔️"}
          label="Scan Status"
          value={item.is_error ? "Error" : "OK"}
        />
      </div>
    </div>
  );
};
